'use client';

import { Header, SimplePage } from "@/ui/controls/page";
import { signIn } from "next-auth/react";
import { urls } from '@/common/urls';
import { redirect } from "next/navigation";
import { features } from "@/be/adapters/features";
import { useState, useEffect } from 'react'
import { SERVICES } from "@/fe/services";
import { CLP } from "@/common/schema/claims-process";

export default function Page() {
  const BOOM_ENV = process.env.NEXT_PUBLIC_BOOM_ENV;
  const FT = features({ BOOM_ENV });
  const URLS = urls({ ts:"NOW" });
  const { CTX } = SERVICES();
  const currentUser = CTX.useCurrentUser();
  const usernameDomains = ["agent355.com", "americanfermentation.com", "angelcitybrewery.com", "angryorchard.com", "asbeer.com", "bevylongdrink.com", "bostonbeer.ca", "bostonbeer.com", "concretebeachbrewery.com", "coneyislandbeer.com", "dfhbeer.com", "dogfish.com", "dogfishinn.com", "drinkhavanalager.com", "drinklomavista.com", "drinkslingers.com", "drinkteapot.com", "hardmountaindew.com", "justbeerproject.com", "lazyrivercider.com", "raiseapint.com", "samofest.com", "samueladams.com", "travelerbeer.com", "trulyhardseltzer.com", "trulyLA.com", "trulyspikedsparkling.com", "twistedtea.com"];

  const [loginUrl, setLoginUrl] = useState(null);
  const [username, setUsername] = useState('');

  useEffect(() => {
    async function fetchLogin() {
      const res = await fetch('/api/login');
      const data = await res.json();
      setLoginUrl(data.loginUrl);
      setUsername(data.username);
    }
    fetchLogin();
  }, []);

  if(!currentUser) {
    if(FT.auth.credentials()) {
      if(username?.length) {
        if(usernameDomains.find(domain => username.toLowerCase().endsWith(domain))) {
          signIn('azure-ad', {}, {
              login_hint: username,
          });
        }
        else {
          signIn('credentials', {
            username: username,
            redirect: true,
            callbackUrl: URLS.claimsApp.distributors.home(),
          });
        }
      }
      else if(loginUrl) {
        redirect(loginUrl + '?LoginUrl=' + encodeURIComponent(location.protocol + '//' + location.host + URLS.login()));
      }
    }
    else {
      signIn('azure-ad');
    }
  }
  else {
    if(currentUser.settings.persona === CLP.ActorType.BBC_APPROVER) {
      redirect(URLS.claimsApp.approvers.home());
    }
    else if(currentUser.settings.persona === CLP.ActorType.DISTRIBUTOR) {
      redirect(URLS.claimsApp.distributors.home());
    }
    redirect(URLS.tracker.claims());
  }

  return (
    <SimplePage>
      <Header>Logging in...</Header>
    </SimplePage>
  );
}

